import { gql } from '@apollo/client';

export const GET_ALL_NOTIFICATIONS = gql`
  query GetAllNotifications($limit: Int, $offset: Int) {
    getAllNotifications(limit: $limit, offset: $offset) {
      notifications {
        nId
        nMessage
        nIsRead
        nType
        nInfo {
          mediaId
          jwMediaId
        }
        nThumbnailUrl
        nUserId
        nCreatedAt
        nUpdatedAt
      }
      total
      isAnyMessageUnRead
    }
  }
`;

export type ApiNotification = {
  nId: string;
  nMessage: string;
  nIsRead: boolean;
  nType: string;
  nInfo?: string | Record<string, unknown> | null;
  nThumbnailUrl?: string | null;
  nUserId: string;
  nCreatedAt: string;
  nUpdatedAt: string;
};

export type GetAllNotificationsData = {
  getAllNotifications: {
    notifications: ApiNotification[];
    total: number;
    isAnyMessageUnRead: boolean;
  };
};

export type GetAllNotificationsVariables = {
  limit?: number;
  offset?: number;
};

export const GET_NOTIFICATION_COUNT = gql`
  query GetNotificationCount($nIsRead: Boolean!) {
    getNotificationCount(nIsRead: $nIsRead)
  }
`;

export type GetNotificationCountData = {
  getNotificationCount: number;
};

export type GetNotificationCountVariables = {
  nIsRead: boolean;
};
